import Vue from 'vue';
import VueRouter from 'vue-router';

import androidMobile from '../components/c-auth/page-android-mobile/component';
import pConfirmation from '../components/c-auth/page-confirmation/component';
import pEnterEmailCode from '../components/c-auth/page-enter-email-code/component';
import pEnterForgotCode from '../components/c-auth/page-enter-forgot-code/component';
import pEnterNumber from '../components/c-auth/page-enter-number/component';
import pEnterPassword from '../components/c-auth/page-enter-password/component';
import pEnterSmsCode from '../components/c-auth/page-enter-sms-code/component';
import pForgotPassword from '../components/c-auth/page-forgot-password/component';
import pIndex from '../components/c-auth/page-index/component.vue';
import pLogout from '../components/c-auth/page-logout/component';
import pProfile from '../components/c-auth/page-profile/component';
import pRedirect from '../components/c-auth/page-redirect/component';
import pRegistration from '../components/c-auth/page-registration/component';
import pRegistrationSuccess from '../components/c-auth/page-registration-success/component';
import Store from '../store/index';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: pIndex,
      children: [
        {
          name: 'enter-number',
          path: '',
          component: pEnterNumber,
          meta: {
            isEnterNumberLinkVisible: false,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: true,
          },
        },
        {
          name: 'enter-sms-code',
          path: '/enter-sms-code',
          component: pEnterSmsCode,
          meta: {
            isEnterNumberLinkVisible: true,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: true,
          },
        },
        {
          name: 'confirmation',
          path: '/confirmation',
          component: pConfirmation,
          meta: {
            isEnterNumberLinkVisible: true,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: true,
          },
        },
        {
          name: 'enter-password',
          path: '/login/enter-password',
          component: pEnterPassword,
          meta: {
            isEnterNumberLinkVisible: true,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: true,
          },
        },
        {
          name: 'enter-forgot-code',
          path: '/enter-forgot-code',
          component: pEnterForgotCode,
          meta: {
            isEnterNumberLinkVisible: true,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: false,
          },
        },
        {
          name: 'forgot-password',
          path: '/forgot-password',
          component: pForgotPassword,
          meta: {
            isEnterNumberLinkVisible: true,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: false,
          },
        },
        {
          name: 'registration',
          path: '/registration',
          component: pRegistration,
          meta: {
            isEnterNumberLinkVisible: true,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: false,
          },
        },
        {
          name: 'enter-email-code',
          path: '/enter-email-code',
          component: pEnterEmailCode,
          meta: {
            isEnterNumberLinkVisible: false,
            isRegistrationLinkVisible: true,
            isForgotPasswordLinkVisible: false,
          },
        },
        {
          name: 'success',
          path: '/success',
          component: pRegistrationSuccess,
          meta: {
            isEnterNumberLinkVisible: false,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: false,
          },
        },
        {
          name: 'redirect',
          path: '/redirect',
          component: pRedirect,
          props: true,
          meta: {
            isEnterNumberLinkVisible: false,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: false,
          },
        },
        {
          name: 'profile',
          path: '/profile',
          component: pProfile,
          meta: {
            isEnterNumberLinkVisible: false,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: false,
          },
        },
        {
          name: 'logout',
          path: '/logout',
          component: pLogout,
          meta: {
            isEnterNumberLinkVisible: false,
            isRegistrationLinkVisible: false,
            isForgotPasswordLinkVisible: false,
          },
        },
      ],
    },
    {
      name: 'mobile',
      path: '/mobile',
      component: androidMobile,
      meta: {
        isEnterNumberLinkVisible: false,
        isRegistrationLinkVisible: false,
        isForgotPasswordLinkVisible: false,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const isAndroid = /Android/i.test(navigator.userAgent);
  const showedMobilePage = JSON.parse(sessionStorage.getItem('showed-mobile-page'));

  if (to.name && to.name !== 'mobile' && isAndroid && !showedMobilePage) {
    sessionStorage.setItem('showed-mobile-page', true);
    return next({ name: 'mobile' });
  }
  if (to.name && to.name === 'mobile') {
    return next();
  }

  if (to.name && to.name === 'logout') {
    return next();
  }

  if (to.name && to.name === 'profile') {
    if (Store.state.configuration.isAuthorized === false) {
      return next('/');
    }
  }

  if (to.name && to.name !== 'profile') {
    if (Store.state.configuration.isAuthorized) {
      return next({ name: 'profile' });
    }
  }

  next();
});

export default router;
